import { useState, useEffect } from 'react'
import axios from 'axios'

const BASE_URL = 'https://cms.lif3.com'

const useFetchCMSData = (endpoint, queryParams = '') => {
  const [data, setData] = useState([])

  useEffect(() => {
    let isCancelled = false

    const fetchData = async (page) => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/${endpoint}?pagination[page]=${page}&pagination[pageSize]=25&populate=*&${queryParams}`
        )
        return response.data
      } catch (error) {
        console.error(`Failed to fetch ${endpoint}:`, error)
      }
    }

    const loadAllData = async () => {
      let currentPage = 1
      let allData = []
      let pageCount

      do {
        const response = await fetchData(currentPage)
        pageCount = response?.meta?.pagination?.pageCount
        allData = allData.concat(response.data)
        currentPage += 1
      } while (currentPage <= (pageCount || 0) && !isCancelled)

      if (!isCancelled) {
        setData(allData)
      }
    }

    loadAllData()

    return () => {
      isCancelled = true
    }
  }, [endpoint, queryParams])

  return data
}

export default useFetchCMSData
